<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
      vs-md="12"
      vs-sm="12"
    >
      <vs-card>
        <h3 class="card-title d-flex">Users</h3>
        <p class="card-subtitle">Details of users accounts.</p>
        <br />
        <div class="table-responsive">
        <table class="table">
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Email Id</th>
            <th>Company</th>
            <th>Country</th>
            <th>Phone</th>
            <th>Industry</th>
            <th>Verified</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
          <tr v-for="(item, index) in users" :key="item._id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.company }}</td>
            <td>{{ item.country }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.industry }}</td>
            <td scope="col" style="text-align: center;">
              <vs-chip class="statusChip" v-if="item.isEmailVerified" color="success">Verified</vs-chip>
              <vs-chip class="statusChip" v-else color="danger">Not Verified</vs-chip>
            </td>
            <td>
              <vue-toggles 
                  checkedText="Active"
                  uncheckedText="Inactive"
                  checkedBg="blue"
                  uncheckedBg="red"
                  :value="item.isActive"
                  @click="toggleActive(item)"
              />
            </td>
            <td style="min-width:90px;">
              <!-- <span>
                <vs-icon
                  style="cursor:pointer;"
                  icon="visibility"
                  @click="viewReports(item)"
                ></vs-icon>
              </span> -->
              
              <span>
                <vs-icon
                  style="cursor:pointer;"
                  icon="delete"
                  v-on:click.native="activateDeletePopup(item)"
                ></vs-icon>
              </span>
            </td>
          </tr>
        </table>
</div>
        <vs-popup title="Reports" :active.sync="viewPopup">
          <template #header>
            <h4 class="not-margin">
              Reports
            </h4>
          </template>
        </vs-popup>

      </vs-card>
    </vs-col>

    <vs-popup
      class="holamundo"
      small
      title="Delete?"
      :active.sync="deletePopup"
    >
      <p>Are you sure you want to Delete {{selectedUser? selectedUser.name : ""}}?</p>
      <div>
        <vs-button @click="deleteUser">Delete</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;"
          @click="deletePopup = false"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
  </vs-row>
</template>
<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import VueToggles from 'vue-toggles';

export default {
  name: "Users",
  components:{
    VueToggles
  },
  data: () => ({
    deletePopup: false,
    viewPopup: false,
    selectedUser:{},
    users: [],
  }),
  computed: {},
  methods: {
    toggleActive(item){
      const newUser = Object.assign(item);
      newUser.isActive = !item.isActive;
      api
        .put(
          API.EDIT_USER+'/'+item._id,
          newUser
        )
        .then(r => {    
          if (r.status !== 200) {
            item.isActive = !item.isActive;          
            this.$vs.notify({
              title: "Active toggle failed",
              text: "User couldn't be modified",
              color: "danger",
              position: "top-right"
            });
          }
        })
        .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.response.data.message,
              color: "danger",
              position: "top-right"
            });
          });
      
    },
    activateDeletePopup(item){
      this.selectedUser = item;
      this.deletePopup = true;
    },
    deleteUser(){
      api
        .delete(
          API.DELETE_USER+'/'+this.selectedUser._id
        )
        .then(r => {    
          if (r.status !== 200) {
            this.$vs.notify({
              title: "Delete user failed",
              text: "User couldn't be deleted",
              color: "danger",
              position: "top-right"
            });
          }
          else {
            this.fetchAllAccounts();
          }
        })
        .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.response.data.message,
              color: "danger",
              position: "top-right"
            });
          });
      this.deletePopup = false;
    },    
    fetchAllAccounts() {
      this.$vs.loading();
      api
        .get(API.ALL_USERS)
        .then(r => {
          if (r.data.data.length === 0) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Data Not Found",
              text: "No Users Found",
              color: "danger",
              position: "top-right"
            });
          } else {
            this.$vs.loading.close();
            this.$data.users = r.data.data.filter(user => user.roleType === 'USER');
          }
        })
        .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: err.response.data.message,
              color: "danger",
              position: "top-right"
            });
          });
    },
    viewReports() {

      this.$data.viewPopup = true;
    },
  },
  created() {
    this.fetchAllAccounts();
  }
};
</script>
